/**
 * Код Ріда — Соломона над GF(2⁸) з поліномом 0x11D (ISO/IEC 18004 §7.5): множення елементів поля, дільник степеня n і остача
 * (кодові слова корекції блоку). Чисті функції.
 */

/** Добуток двох елементів GF(2⁸) за модулем x⁸ + x⁴ + x³ + x² + 1. */
export function rsMultiply(x: number, y: number): number {
  let z = 0;
  for (let i = 7; i >= 0; i--) {
    z = (z << 1) ^ ((z >>> 7) * 0x11d);
    z ^= ((y >>> i) & 1) * x;
  }
  return z & 0xff;
}

/** Коефіцієнти породжувального полінома степеня `degree` (без старшого 1), від старших до молодших. */
export function rsDivisor(degree: number): number[] {
  const result = new Array<number>(degree).fill(0);
  result[degree - 1] = 1;
  let root = 1;
  for (let i = 0; i < degree; i++) {
    for (let j = 0; j < result.length; j++) result[j] = rsMultiply(result[j] ?? 0, root) ^ (j + 1 < result.length ? result[j + 1] ?? 0 : 0);
    root = rsMultiply(root, 0x02);
  }
  return result;
}

/** Остача від ділення даних блоку на породжувальний поліном — кодові слова корекції помилок. */
export function rsRemainder(data: readonly number[], divisor: readonly number[]): number[] {
  const result = divisor.map(() => 0);
  for (const b of data) {
    const factor = b ^ (result.shift() ?? 0);
    result.push(0);
    divisor.forEach((coef, i) => { result[i] = (result[i] ?? 0) ^ rsMultiply(coef, factor); });
  }
  return result;
}
